import React, { useState } from "react";
import { RiCloseCircleFill } from "react-icons/ri";
import { CellProps } from "../cell-interface";
import classes from "./rating_cell.module.scss";
import Rating from '@mui/material/Rating';


export default function RatingCell({ cellValue, onUpdate,readOnly }: CellProps) {
  const [value, setValue] = useState<number | undefined>();
  function updateRating(newValue: React.SyntheticEvent) {
    const target = newValue.currentTarget as HTMLInputElement;
    setValue(Number(target.value));
    onUpdate(Number(target.value));
  }

  function handleClearValue() {
    setValue(undefined);
    onUpdate(undefined);
  }
  return (
    <div className={classes.ratingCell}>
      <Rating size="small"
        value={(value || cellValue) ?? 0}
        readOnly={readOnly}
        onChange={(newValue) => {
          updateRating(newValue);
        }}
      />
       {(cellValue && !readOnly )  && (
          <RiCloseCircleFill
            onClick={handleClearValue}
            className={classes.clearIcon}
          />
        )}
    </div>
  );
}
